const IntroSection = (props) => {
  const { title, titleSize, desSize, description } = props;

  return (
    <div>
      <p className={`${titleSize || 'text-lg'} font-[800]`}>{title}</p>
      <p className={`${desSize || 'text-sm'} text-02-dim-gray`}>{description}</p>
    </div>
  );
};

export default IntroSection;
